export default "__VITE_ASSET__D44WgY6s__"